import { render, staticRenderFns } from "./Opened.vue?vue&type=template&id=2594f65a&scoped=true"
import script from "./Opened.vue?vue&type=script&lang=js"
export * from "./Opened.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2594f65a",
  null
  
)

export default component.exports